import * as types from './constants';

// Send Sendbird Batch Message
export const sendSendbirdBatchMessageRequest = data => (
  { type: types.SEND_SENDBIRD_BATCH_MESSAGE_REQUEST, payload: data }
);

export const sendSendbirdBatchMessageDone = data => (
  { type: types.SEND_SENDBIRD_BATCH_MESSAGE_DONE, payload: data }
);

export const sendSendbirdBatchMessageFailed = errors => (
  { type: types.SEND_SENDBIRD_BATCH_MESSAGE_FAILED, payload: errors }
);

export const sendSendbirdBatchMessageReset = () => (
  { type: types.SEND_SENDBIRD_BATCH_MESSAGE_RESET }
);